import { useSelector } from 'react-redux';
import { getText } from '../../common/utils/helpers';
import * as yaml from 'js-yaml';

export const useTranslations = (label) => {
  const translationsData = useSelector(
    (state: any) => state.app.translationsData
  );
  const lng = useSelector((state: any) => state.app.lng);

  const rawText: string = getText(translationsData?.content, label, lng);
  const text: string = rawText?.replace(/(?:\r\n|\r|\n)/g, '<br>');

  return text || '';
};

export const useDynamicTranslations = (code, passedLng?) => {
  const translationsData = useSelector(
    (state: any) => state.app.translationsData
  );
  const lng = useSelector((state: any) => state.app.lng);

  const tableData =
    translationsData?.content?.table &&
    yaml.load(translationsData?.content?.table);

  const currentData = tableData?.find((item) => item.code === code);

  if (!currentData) {
    return '';
  }

  const currentLng = passedLng || lng;
  const currentLabel = currentData[currentLng] || currentData.lv;

  // const text: string = currentLabel?.replace(/(?:\r\n|\r|\n)/g, '<br>');

  return currentLabel || '';
};
